import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDelete, fetchList, fetchUpdate } from '@/api/PMS/repair/proprietorAudit';
import waves from '@/directive/waves'; // 水波纹指令

export default {
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        nickName: '',
        customerPhone: '',
        auditStatus: null
      },
      statusOptions: [{
        value: '0',
        label: '待审核'
      }, {
        value: '1',
        label: '通过'
      }, {
        value: '2',
        label: '未通过'
      }]
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handlePass: function handlePass(obj) {
      var _this2 = this;

      this.$confirm('你确定是要审核通过, 是否继续?', '提示').then(function () {
        var listData = {
          linkId: obj.linkId,
          houseId: obj.houseId,
          areaGroupId: obj.areaGroupId,
          customerName: obj.customerName,
          auditStatus: 1,
          weixinOpenid: obj.weixinOpenid
        };
        fetchUpdate(listData).then(function (response) {
          _this2.getList();

          _this2.Alert({
            alertType: 'add',
            message: '审核成功！'
          });
        });
      });
    },
    handleUnPass: function handleUnPass(obj) {
      var _this3 = this;

      this.$confirm('你确定是要审核不通过, 是否继续?', '提示').then(function () {
        var listData = {
          linkId: obj.linkId,
          houseId: obj.houseId,
          areaGroupId: obj.areaGroupId,
          customerName: obj.customerName,
          auditStatus: 2,
          weixinOpenid: obj.weixinOpenid
        };
        fetchUpdate(listData).then(function (response) {
          _this3.getList();

          _this3.Alert({
            alertType: 'add',
            message: '审核成功！'
          });
        });
      });
    },
    delete: function _delete(linkIds) {
      var _this4 = this;

      if (linkIds.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          fetchDelete({
            ids: linkIds
          }).then(function (response) {
            if (response.data.code === 200) {
              _this4.getList();

              _this4.Alert({
                alertType: 'delete'
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(linkId) {
      var linkIds = [];
      linkIds.push(linkId);
      this.delete(linkIds);
    },
    handleDeletes: function handleDeletes() {
      var linkIds = [];
      this.multipleSelection.forEach(function (row) {
        linkIds.push(row.linkId);
      });
      this.delete(linkIds);
    }
  }
};